export enum EAuthorizationProgressBarStep {
  EMPTY = 'empty',
  HALF = 'half',
  FULL = 'full',
}
